export const GENERIC_GEOJSON_TITLE_SYMBOL = Symbol("GENERIC_GEOJSON_FEATURE_TITLE");
export const GENERIC_GEOJSON_COLOUR_SYMBOL = Symbol("GENERIC_GEOJSON_FEATURE_COLOUR");
